import { httpCreate } from './http';
const http = httpCreate('/srv/wx-dictionary-value');
export const wxDicctioaryValue = {
	area() {
		return http.get('area');
	},
};
